// extracted by mini-css-extract-plugin
export default {"nav":"InterProMenu_styles__nav___eb","interpro-menu":"InterProMenu_styles__interpro-menu___ea","icon":"InterProMenu_styles__icon___ad"};